import * as React from "react";
import { IS_DEPLOYMENT_ENV_PROD } from "../envVariables";

interface Props {
  timestamp?: number;
  prefix?: string;
}

export const LastUpdated: React.FC<Props> = ({ timestamp, prefix = "Updated" }) => {
  const [, forceUpdate] = React.useReducer((x) => x + 1, 0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      forceUpdate();
    }, 10000); // Update every 10 seconds to refresh relative time

    return () => clearInterval(interval);
  }, []);

  if (!timestamp) return null;

  const getRelativeTime = () => {
    const now = Date.now();
    const diff = now - timestamp;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    if (seconds < 10) return "just now";
    if (seconds < 60) return `${seconds} seconds ago`;
    if (minutes === 1) return "1 minute ago";
    if (minutes < 60) return `${minutes} minutes ago`;
    if (hours === 1) return "1 hour ago";
    if (hours < 24) return `${hours} hours ago`;

    return new Date(timestamp).toLocaleString();
  };

  if (IS_DEPLOYMENT_ENV_PROD) {
    return null;
  }

  return (
    <span className="text-sm text-gray-500">
      {prefix} {getRelativeTime()} <span className="text-xs">DEBUG</span>
    </span>
  );
};
